import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { SEE_ALL } from '../constants/projectConstants';
import HorizontalHomeCarousel from './HorizontalHomeCarousel';
import NoDataFound from './NoDataFound';
import { BLACK_DOWN_ARROW } from '../constants/assetConstants';
import SkeletonLoaderUI, { SKELETON_LAYOUT, SKELETON_LOADER_TYPE } from '../skeletonLoaderUI/SkeletonLoaderUI';
import { Mixpanel } from './Mixpanel';

const GridSectionNew = ({
  title,
  seeAllLink,
  onSeeAllClick = () => {},
  carouselData,
  modelType,
  onClick,
  showFavoriteIcon = false,
  emptyDisplay,
  onSuccess,
  className,
  hasMore,
  fetchMoreData,
  fetchMoreLoading,
  onEdit,
  loading,
  capitalize,
  curatorProp,
  itemsTotal,
  showTotal = true,
  mx_event,
}) => {
  const prevDataRef = useRef(carouselData);
  const slideArrowRef = useRef();
  const slideContainerRef = useRef();

  if (carouselData.length === 0 && loading) {
    prevDataRef.current = prevDataRef.current;
  } else {
    prevDataRef.current = carouselData;
  }

  // hiding 'See all' button when the cards are less than the window width
  const hideSeeAll = Math.floor((window.innerWidth - 270) / 296) < carouselData?.length;
  
  const data = carouselData.length === 0 ? prevDataRef.current : carouselData;
  
  const hasData = carouselData.length !== 0;

  const [randomw] = useState(Math.random());

  const showNewCaoursel = !loading && hasData;
  const showOldCarousel = loading && data.length;
  const showCarousel = showNewCaoursel || showOldCarousel;

  const handleSeeAll =()=>{
    console.log("mx: "+ mx_event);
    Mixpanel.track(true,mx_event);
    onSeeAllClick;
  }

  return (
    <div className={`px-0 grid-section ${className || ''}`} fluid="true">
      {title && (
        <div className="carousel-card-header">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <Link className="see_all_link" to={seeAllLink} onClick={handleSeeAll}>
              <h5 className="mb-0 head-h5">{title} {!loading && carouselData.length >= 0 && showTotal ? <small>({itemsTotal || carouselData.length})</small> : null}</h5>
            </Link>

            {(!loading && seeAllLink && carouselData?.length === 0) && (
            <span ref={slideArrowRef} role="button" className={`downarrow ${carouselData?.length === 0 ? 'aUp' : 'aDown'}`} onClick={() => {
                
                const a = slideArrowRef.current.className;
                slideArrowRef.current.className = a.includes('aDown') ? a.replace('aDown', 'aUp') : a.replace('aUp', 'aDown')

                const c = slideContainerRef.current.className;
                slideContainerRef.current.className = c.includes('slideDown') ? c.replace('slideDown', 'slideUp') : c.replace('slideUp', 'slideDown')
              }}
            >
              <img src={BLACK_DOWN_ARROW} alt="" width={16} height={10} />
            </span>
            )}
          </div>
          {(!loading && seeAllLink && carouselData?.length !== 0) && hideSeeAll && (
            <Link className="see_all_link" to={seeAllLink} onClick={handleSeeAll}>
              {SEE_ALL}
            </Link>
          )}
        </div>
      )}
      <div ref={slideContainerRef} className={`
        w-100 slide-container 
        ${loading ? 'loading' : ''}
        ${(!loading && carouselData?.length === 0) ? 'slideUp' : 'slideDown'}
        `} style={{ position: 'relative' }}>
        {!loading && !hasData && (
          <div className="empty-area">{emptyDisplay ?? <NoDataFound title={title} />}</div>
        )}

        {
          loading
          ?
          <SkeletonLoaderUI type={SKELETON_LOADER_TYPE.THUMBNAIL_CARD} layout={SKELETON_LAYOUT.HORIZONTAL} />
          :
          <HorizontalHomeCarousel
            data={data}
            onClick={onClick}
            onEdit={onEdit}
            showFavoriteIcon={showFavoriteIcon}
            onSuccess={onSuccess}
            hasMore={hasMore}
            fetchMoreData={fetchMoreData}
            loading={fetchMoreLoading}
            modelType={modelType}
            capitalize={capitalize}
            curatorProp={curatorProp}
          />
        }
      </div>
    </div>
  );
};

export default GridSectionNew;
